/**
 * 1.3.82: 利用規約ページ
 * サービス利用規約
 */

import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="戻る"
          >
            <ArrowLeft className="w-5 h-5 text-gray-600" />
          </button>
          <h1 className="text-xl font-bold text-gray-900">利用規約</h1>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          {/* Title Section */}
          <div className="bg-gradient-to-r from-primary to-purple-600 p-8 text-white">
            <h2 className="text-2xl font-bold mb-2">利用規約</h2>
            <p className="text-purple-100 text-sm">Terms of Service</p>
          </div>

          {/* Terms Content */}
          <div className="p-8 space-y-8">
            {/* Introduction */}
            <section>
              <p className="text-gray-700 leading-relaxed">
                本利用規約（以下「本規約」）は、YUIChat（以下「当サービス」）の利用条件を定めるものです。
                ユーザーの皆様（以下「ユーザー」）には、本規約に同意いただいた上で、当サービスをご利用いただきます。
              </p>
            </section>

            {/* Article 1 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">1</span>
                適用
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  本規約は、ユーザーと当サービス運営者との間の当サービスの利用に関わる一切の関係に適用されるものとします。
                </p>
              </div>
            </section>

            {/* Article 2 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">2</span>
                利用登録
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  登録希望者が当サービスの定める方法によって利用登録を申請し、
                  当サービスがこれを承認することによって、利用登録が完了するものとします。
                </p>
                <p>
                  当サービスは、以下の場合には利用登録の申請を承認しないことがあります：
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>虚偽の事項を届け出た場合</li>
                  <li>本規約に違反したことがある者からの申請である場合</li>
                  <li>その他、当サービスが利用登録を相当でないと判断した場合</li>
                </ul>
              </div>
            </section>

            {/* Article 3 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">3</span>
                アカウント管理
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  ユーザーは、自己の責任において、当サービスのアカウント情報を適切に管理するものとします。
                </p>
                <p>
                  ユーザーは、いかなる場合にも、アカウントを第三者に譲渡または貸与することはできません。
                </p>
              </div>
            </section>

            {/* Article 4 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">4</span>
                利用料金および支払方法
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  ユーザーは、当サービスの有料部分の対価として、当サービスが別途定める利用料金を、
                  当サービスが指定する方法により支払うものとします。
                </p>
                <p>
                  ユーザーが利用料金の支払を遅滞した場合、ユーザーは年14.6%の割合による遅延損害金を支払うものとします。
                </p>
              </div>
            </section>

            {/* Article 5 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">5</span>
                禁止事項
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>ユーザーは、当サービスの利用にあたり、以下の行為をしてはなりません：</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>法令または公序良俗に違反する行為</li>
                  <li>犯罪行為に関連する行為</li>
                  <li>当サービスのサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
                  <li>当サービスの運営を妨害するおそれのある行為</li>
                  <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
                  <li>不正アクセスをし、またはこれを試みる行為</li>
                  <li>他のユーザーに成りすます行為</li>
                  <li>当サービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
                  <li>その他、当サービスが不適切と判断する行為</li>
                </ul>
              </div>
            </section>

            {/* Article 6 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">6</span>
                サービスの提供の停止等
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  当サービスは、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく、
                  サービスの全部または一部の提供を停止または中断することができるものとします：
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>サービスにかかるシステムの保守点検または更新を行う場合</li>
                  <li>地震、落雷、火災、停電その他の不可抗力により、サービスの提供が困難となった場合</li>
                  <li>その他、当サービスがサービスの提供が困難と判断した場合</li>
                </ul>
              </div>
            </section>

            {/* Article 7 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">7</span>
                退会
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  ユーザーは、当サービスの定める退会手続により、いつでも退会できるものとします。
                </p>
              </div>
            </section>

            {/* Article 8 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">8</span>
                免責事項
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  当サービスは、当サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、
                  特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます）
                  がないことを明示的にも黙示的にも保証しておりません。
                </p>
                <p>
                  当サービスは、当サービスに起因してユーザーに生じたあらゆる損害について、
                  当サービスの故意または重過失による場合を除き、一切の責任を負いません。
                </p>
              </div>
            </section>

            {/* Article 9 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">9</span>
                サービス内容の変更等
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  当サービスは、ユーザーへの事前の告知なくして、サービスの内容を変更したり、
                  サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
                </p>
              </div>
            </section>

            {/* Article 10 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">10</span>
                利用規約の変更
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  当サービスは、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。
                  なお、本規約の変更後、当サービスの利用を開始した場合には、当該ユーザーは変更後の規約に同意したものとみなします。
                </p>
              </div>
            </section>

            {/* Article 11 */}
            <section>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center text-sm font-bold">11</span>
                準拠法・裁判管轄
              </h3>
              <div className="pl-10 text-gray-700 space-y-3">
                <p>
                  本規約の解釈にあたっては、日本法を準拠法とします。
                </p>
                <p>
                  当サービスに関して紛争が生じた場合には、東京地方裁判所を専属的合意管轄とします。
                </p>
              </div>
            </section>

            {/* Last Updated */}
            <div className="pt-8 border-t border-gray-100 text-center text-sm text-gray-400">
              制定日：2026年2月1日
            </div>
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-8 text-center">
          <button
            onClick={() => {
              // 1.3.84: 使用 sessionStorage 传递滚动意图，更可靠
              sessionStorage.setItem('scrollToFooter', 'true');
              window.location.href = '/';
            }}
            className="px-6 py-3 text-primary hover:text-primary-dark font-medium transition-colors"
          >
            ← トップページに戻る
          </button>
        </div>
      </main>
    </div>
  );
};
